import AppContext from "@/AppContext";
import { loginPopup, registerPopup } from "@/Atoms";
import TopNavigationDesktop from "@/components/navigation-menu/desktop";
import BottomNavigationMobile from "@/components/navigation-menu/mobile/bottom-navigation";
import TopNavigationMobile from "@/components/navigation-menu/mobile/top-navigation";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useAtom } from "jotai";
import { useRouter } from "next/router";
import { useContext } from "react";

export default function Navbar({
  user,
  logout,
  hideTopMobileNavigation,
  hideBottomMobileNavigation,
}) {
  const appContext = useContext(AppContext);
  const { planSubscription, loading, refreshUserSubscription } =
    appContext.state;
  const router = useRouter();
  const isMobile = useIsMobile();

  const [openLoginPopup, setOpenLoginPopup] = useAtom(loginPopup);
  const [openRegisterPopup, setOpenRegisterPopup] = useAtom(registerPopup);

  // 🔒 Do not render on /account or any sub-routes like /account/settings
  if (router.pathname.startsWith("/account") && isMobile) return null;

  const handleOpenLogin = () => setOpenLoginPopup(true);
  const handleOpenRegister = () => setOpenRegisterPopup(true);
  const handleCloseLogin = () => setOpenLoginPopup(false);
  const handleCloseRegister = () => setOpenRegisterPopup(false);

  const navigationProps = {
    handleOpenLogin,
    handleOpenRegister,
    handleCloseLogin,
    handleCloseRegister,
    planSubscription,
  };

  return isMobile ? (
    <>
      {!hideTopMobileNavigation && (
        <TopNavigationMobile user={user} logout={logout} {...navigationProps} />
      )}
      {!hideBottomMobileNavigation && (
        <BottomNavigationMobile
          user={user}
          logout={logout}
          {...navigationProps}
        />
      )}
    </>
  ) : (
    <TopNavigationDesktop user={user} logout={logout} {...navigationProps} />
  );
}
